export const filterObject = <K>(
  obj: Record<string, K>,
  predicate: (key: string, value: K) => boolean
): Record<string, K> => {
  return Object.fromEntries(
    Object.entries(obj).filter(([key, value]) => predicate(key, value))
  );
};

export const mapObject = <
  K extends Record<keyof K, K[keyof K]>,
  T extends Record<keyof K, T[keyof K]>,
>(
  obj: K,
  mapper: (key: keyof K, value: K[keyof K]) => T[keyof K]
): T =>
  Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key as keyof K,
      mapper(key as keyof K, value as K[keyof K]),
    ])
  ) as T;
